import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <g>
    <path d="M6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h6.3c-.4-.6-.7-1.3-1-2H6V4h7v5h5v2c.7 0 1.4.1 2 .3V8l-6-6H6zm17.2 19.8l-1.5-1.5c.5-.8.8-1.8.8-2.8 0-2.8-2.2-5-5-5-2.7 0-5 2.3-5 5 0 2.8 2.2 5 5 5 1 0 2-.3 2.8-.8l1.5 1.5c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4zm-5.7-1.3c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z" />
  </g>,
  'FileSearch',
);
